<template>
  <PgDialogSelect
    v-if="dialogProps"
    :visible="visible"
    v-bind="dialogProps"
    @close="onOk('cacel')"
    @closed="closed"
    @on-ok="onOk"
  >
  </PgDialogSelect>
</template>
<script setup>
import PgDialogSelect from './main.vue'
import { reactive, shallowRef, ref, getCurrentInstance } from 'vue'

const props = reactive({
  cacelText: null,
  secoundConfirmText: null,
  secoundConfirmType: 'primary',
  confirmText: '确 认',
  beforeClose: null, //非配置项
  close: null, //非配置项
})

const { proxy } = getCurrentInstance()
//关闭动画完成之后的回调
const closed = () => {
  props.close?.()
  proxy.$destroy(true)
  // proxy.$el.parentNode.removeChild(proxy.$el)
}

const visible = ref(true)
const dialogProps = shallowRef(null)
//关闭方法
const onClose = () => {
  visible.value = false
}
//按钮事件
const onOk = (dialogData) => {
  props.beforeClose({ dialogData, onClose, type: dialogData === 'cacel' ? 'cacel' : 'confim' })
}
const show = (options) => {
  const { beforeClose, close, ...tempDialogProps } = options
  props.beforeClose = beforeClose
  props.close = close
  dialogProps.value = tempDialogProps
}

defineExpose({
  show,
  setProps(key, val) {
    props[key] = val
  },
})
</script>
